export default {
  name: "POIConferenceFields",
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    maxNumberOfHighlights: 8
  }),
  mounted() {},
  methods: {
    removeHighlight(index) {
      if (index < 0) return;
      this.editedItem.conferenceInfos.highlights.splice(index, 1);
    },
    addHighlight() {
      if (
        this.editedItem.conferenceInfos.highlights.length >=
        this.maxNumberOfHighlights
      )
        return;
      this.editedItem.conferenceInfos.highlights.push("");
    }
  },
  computed: {
    isReadOnly() {
      return this.isOwnedBySubPrincipal;
    }
  }
};
